export default __webpack_public_path__ + "static/media/icon-horaire.2e34a303.svg";